export default {"src":"/_next/static/media/offer-black.4efc57a4.svg","height":992,"width":225};